export default "__VITE_ASSET__xcN1Iq62__"